import type { LifecycleStatus } from '@/types/enums';

/**
 * Shared shapes for the generic “versioned group + instances” UI pattern.
 */
export interface GenericGroup {
    id: string;
    versioned_group_name: string;
    is_active: boolean;
    is_template?: boolean;
    current_instance_id?: string;
    draft_id?: string;
    instances: GenericInstance[];
}

export interface GenericInstance {
    id: string;
    version_number: number | null;
    version_instance_lifecycle: LifecycleStatus;
    /** Present when the layout shows “published on” for non-production releases. */
    published_at?: string | null;
    /** Last edit; the sidebar shows it on the draft row, which has no publish date. */
    updated_at?: string | null;
}

/** Policy list filter: soft-deleted visibility ('active' = not deleted). */
export type PolicyVisibilityFilter = 'active' | 'deleted' | 'all';

/** Policy list filter: the policy's on/off state (`is_active`). */
export type PolicyProductionFilter = 'all' | 'in_production' | 'out_of_production';

/** Navigation panes shared by versioning-style UIs (hub → details → editor). */
export enum VersioningManagerActiveView {
    LIST = 'list',
    DETAILS = 'details',
    WIZARD = 'wizard',
    ENTITIES = 'entities',
}

export interface VersioningApi<G extends GenericGroup, I extends GenericInstance> {
    fetchData: () => Promise<G[]>;
    createGroup: (payload: any) => Promise<G>;
    createDraft: (groupId: string, payload: any) => Promise<I>;
    promote: (groupId: string, instanceId: string) => Promise<any>;
    toggleActive: (groupId: string, active: boolean) => Promise<any>;
    deleteGroup?: (groupId: string) => Promise<any>;
}
